export const release = '77d6f47d76cc41ac54ac1e8f7fa1e786ee2cbffe';
